import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SearchFormModule } from '../../searchForm';

import { SearchForProductsFilterComponent } from './search-for-products-filter.shared.component';

@NgModule({
    declarations: [
        SearchForProductsFilterComponent,
    ],
    imports: [
        CommonModule,
        SearchFormModule,
    ],
    exports: [
        SearchForProductsFilterComponent,
    ],
})
export class SearchForProductsFilterModule { }
